import React from 'react';
import { Field } from 'redux-form';
// import {
//   isInteger,
// } from '../../../../components/reduxFields';
import {
  normalizeRate,
  renderAutoCompleteMultipleSelection,
  renderAutoCompleteSingleSelect,
  renderDateField,
  renderTextField,
  renderCheckBox,
  isCustomReferenceNumber
} from '../../../../components/reduxFields';
import RaisedButton from 'material-ui/RaisedButton';

function FilterForm(props) {

  let {
    handleNewRequest,
    handleNewRequestMultiSelect,
    masterInsuranceCompanies,
    masterPaymentDescription,
    masterTags,
    masterPaymentTypes,
    FromDate,
    patientList,
    ToDate,
    onDateChange,
    onFilterFormAmountChange,
    PaymentDate,
    DepositDate,
    handleSearchPaymentDetails,
    handleReset,
    sourceName,
    //modeName,
    guarantorList,
    masterClaimPaymentStatus,
    isExcludeTagHandler,
    masterTagsAll
  } = props;

  let sourceArray = [{ id: 1, value: 'Self' },
  //{ id: 2, value: 'Guarantor' },
  { id: 3, value: 'Insurance' },
  ];
  // console.log('masterInsuranceCompanies.............', masterInsuranceCompanies);
  // console.log('sourceName.............', sourceName);

  return (
    <div>
      {/* <div className="row">
        <div className="col-sm-4 insfield require">
          <Field
            name="PayerId"
            label="Insurance Company"
            handleNewRequest={handleNewRequest}
            options={masterInsuranceCompanies}
            component={renderAutoCompleteSingleSelect}
          />
        </div>
        <div className="col-sm-4 insfield require">
          <Field
            name="PaymentTypeId"
            label="Payment Type"
            handleNewRequest={handleNewRequest}
            options={masterPaymentTypes}
            component={renderAutoCompleteSingleSelect}/>
        </div>
        <div className="col-sm-4 require">
          <Field name="ChequeNo"
            floatingLabelText="Cheque No."
            maxLength="50"
            component={renderTextField} />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 require">
          <Field name="Amount"
            floatingLabelText="Amount($)"
            maxLength="10"
            normalize={normalizeRate}
            component={renderTextField} />
        </div>
        <div className="col-sm-4 require">
          <Field name="PaymentDate"
            placeholder="Date"
            locale="en-US"
            selected={PaymentDate}
            onDateChange={onDateChange}
            openToYearSelection = {true}
            component={renderDateField} />
        </div>
      </div> */}
      <div className="row">
        <div className="col-sm-4 insfield require mt-35">
          <Field
            name="Source"
            label="Payment Source"
            options={sourceArray}
            handleNewRequest={handleNewRequest}
            component={renderAutoCompleteSingleSelect}
          />
        </div>
        {(sourceName || '').toLowerCase() === 'self' || (sourceName || '').toLowerCase() === 'guarantor' ?
          <div className="col-sm-4 insfield require mt-35">
            <Field
              name="PatientId"
              label="Client Name"
              handleNewRequest={handleNewRequest}
              options={patientList}
              component={renderAutoCompleteSingleSelect} />
          </div>
          : null}
        {(sourceName || '').toLowerCase() === 'guarantor' ?
          <div className="col-sm-4 insfield require mt-35">
            <Field
              name="GuarantorId"
              label="Guarantor Name"
              handleNewRequest={handleNewRequest}
              options={guarantorList}
              component={renderAutoCompleteSingleSelect} />
          </div>
          : null}
        {(sourceName || '').toLowerCase() === 'insurance' ?
          <div className="col-sm-4 insfield require mt-35">
            <Field
              name="PayerId"
              label="Insurance Company"
              handleNewRequest={handleNewRequest}
              options={masterInsuranceCompanies}
              component={renderAutoCompleteSingleSelect}
            />
          </div>
          : null}
      </div>
      <div className="row">
        <div className="col-sm-4 insfield require mt-35">
          <Field
            name="DescriptionTypeId"
            label="Payment Description"
            handleNewRequest={handleNewRequest}
            options={masterPaymentDescription}
            component={renderAutoCompleteSingleSelect} />
        </div>
        <div className="col-sm-4 insfield require mt-35">
          <Field
            name="PaymentTypeId"
            label="Payment Type"
            handleNewRequest={handleNewRequest}
            options={masterPaymentTypes}
            component={renderAutoCompleteSingleSelect} />
        </div>
        <div className="col-sm-4">
          <Field name="Amount"
            floatingLabelText="Amount($)"
            maxLength="20"
            // normalize={normalizeRate}
            onChange={onFilterFormAmountChange}
            component={renderTextField} />
        </div>
      </div>
      <div className="row">
        {/* {(modeName || '').toLowerCase() === 'check' || (modeName || '').toLowerCase() === 'check ins' ? */}
          <div className="col-sm-4">
            <Field name="CustomReferenceNumber"
              floatingLabelText="Reference Number"
              maxLength="50"
              normalize={isCustomReferenceNumber}
              component={renderTextField} />
          </div>
          {/* : null} */}
        <div className="col-sm-4 require">
          <Field name="PaymentDate"
            placeholder="Check Date"
            locale="en-US"
            selected={PaymentDate}
            onDateChange={onDateChange}
            openToYearSelection={true}
            component={renderDateField} />
        </div>
        <div className="col-sm-4">
          <Field name="DepositDate"
            placeholder="Deposit Date"
            locale="en-US"
            selected={DepositDate}
            onDateChange={onDateChange}
            openToYearSelection={true}
            component={renderDateField} />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 require">
            <Field name="TotalCheckAmount"
              floatingLabelText="Total Check Amount($)"
              maxLength="20"
              // normalize={normalizeRate}
              component={renderTextField} />
          </div>
      </div>
      <div className="panel_title"><h3>Filter Claims</h3><i className="flaticon flaticon-agenda-1"></i></div>
      <div className="row">
        <div className="col-sm-4 insfield mt-35">
          <Field
            name="PayerIds"
            label="Insurance Company"
            handleNewRequest={handleNewRequest}
            options={masterInsuranceCompanies}
            component={renderAutoCompleteSingleSelect}
          />
        </div>
        <div className="col-sm-4 insfield mt-35">
          <Field
            name="PatientIds"
            label="Client Name"
            handleNewRequest={handleNewRequestMultiSelect}
            options={patientList}
            component={renderAutoCompleteMultipleSelection} />
        </div>
        <div className="col-sm-4 insfield mt-35 ">
          <Field
            name="ClaimPaymentStatus"
            label="Payment Status"
            handleNewRequest={handleNewRequestMultiSelect}
            options={masterClaimPaymentStatus}
            component={renderAutoCompleteMultipleSelection}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 insfield mt-35">
          <Field
            name="patientTags"
            label="Tags"
            handleNewRequest={handleNewRequestMultiSelect}
            options={masterTags}
            component={renderAutoCompleteMultipleSelection} />
        </div>
        <div className="col-sm-4 ">
          <Field name="FromDate"
            placeholder="Claim Start Date"
            locale="en-US"
            selected={FromDate}
            onDateChange={onDateChange}
            openToYearSelection={true}
            component={renderDateField} />
        </div>
        <div className="col-sm-4">
          <Field name="ToDate"
            placeholder="Claim End Date"
            locale="en-US"
            minDate={FromDate}
            selected={ToDate}
            onDateChange={onDateChange}
            openToYearSelection={true}
            component={renderDateField} />
        </div>
      </div>
      <div className="row">         
        <div className="col-sm-4 insfield mt-10">
          <Field name="totalAmount"
            hintText={'Total Amount(0.00)'}
            disabled={true}
            normalize={normalizeRate}
            component={renderTextField} />
        </div>
        <div className="col-sm-4 insfield mt-20">
          {masterTagsAll.length > 0 && <Field
            name="ExcludeTag"
            label="Exclude Tag"
            component={renderCheckBox}
            onChange={isExcludeTagHandler}
          />}
        </div>
        <div className="col-sm-4 btn_rt reset-btn">
          <RaisedButton className="grey_btn" onTouchTap={handleSearchPaymentDetails} primary={true}>Filter</RaisedButton>
          <RaisedButton className="grey_btn ml_15" onTouchTap={handleReset}>Reset</RaisedButton>
        </div>        
      </div>
    </div>
  );
}

// const PaymentDetailFilterForm = reduxForm({
//   form: 'PaymentDetailFilterForm',
//   validate: validateFilters,
// })(FilterForm);

export default FilterForm;



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/payment-details_filterForm.js